import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface AdminStatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
  className?: string;
}

const AdminStatCard = ({ title, value, icon: Icon, trend, className }: AdminStatCardProps) => {
  return (
    <div className={cn(
      'bg-card border border-border rounded-xl p-5 shadow-sm hover:shadow-md hover:border-primary/20 transition-all duration-200 flex flex-col',
      className
    )}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon className="w-4 h-4 text-primary" />
        </div>
      </div>
      <div className="mt-3 flex-1 flex flex-col justify-end">
        <p className="text-2xl font-bold text-foreground">{value}</p>
        {trend && (
          <div className="flex items-center gap-2 mt-1">
            <span className={cn(
              "inline-flex items-center gap-1 text-xs font-medium",
              trend.isPositive !== false
                ? "text-emerald-600 dark:text-emerald-400" 
                : "text-destructive"
            )}>
              {trend.isPositive !== false ? '+' : '-'}{Math.abs(trend.value)}%
            </span>
            <span className="text-xs text-muted-foreground">{trend.label}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminStatCard;
